<template>
    <ul class="form_list">
        <li class="title">
            시간당 예약 가능 인원
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span class="tooltip">해당 시간 내에 예약 가능 인원이 모두 차 있는 경우 고객이 직접 예약시 해당 시간을 선택할 수 없습니다.</span>
            </span>
        </li>
        <li class="cont">
            <select class="input_s w_full" :disabled="!isActive" v-model="capacity" @change="action_MaxCapacity">
                <option v-for="i in 30" :key="i" :value="i">{{ i }} 명</option>
            </select>
        </li>
    </ul>
</template>


<script>
export default {
    props: {
        appMaxCapacity: Number,
        isActive: Boolean
    },
    data() {
        return {
            capacity: 0
        }
    },
    watch: {
        appMaxCapacity: {
            immediate: true,
            handler: function(newValue) {
                this.capacity = newValue
                if (this.capacity == 0) {
                    this.capacity = 1
                }
            }
        },
        capacity: {
            immediate: true,
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) {
                    return
                }
                this.updateValue()
            }
        }
    },
    methods: {
        action_MaxCapacity(e) {
            this.updateValue('appMaxCapacity', Number(e.target.value))
        },
        updateValue(key, value) {
            let data = {
                key: key,
                value: value
            }
            this.$emit('updateValue', data)
        },
    }
}
</script>